<template>
    <div class="responsive-table mass-update-table">
        <table class="attTable">
            <tr>
                <th>
                    <!--<vs-checkbox ref="allStudentCheck" v-model="checkAllStudent"-->
                                 <!--:checked="selectAllStudent()"></vs-checkbox>-->
                    <div class="pen-checkbox">
                        <div class="pen-checkbox_item">
                            <input type="checkbox" ref="allStudentCheck" v-model="checkAllStudent"
                                   :checked="selectAllStudent()" id="checkAllStudent"/>
                            <label for="checkAllStudent"></label>
                        </div>
                    </div>
                </th>
                <th>Student Name</th>
                <th>Activity</th>
                <!--<th>Remarks</th>-->
                <th>Action</th>
            </tr>
            <tr v-for="(item,i) in newClassStudent" ref="selectedClassStudent_list"
                :key="item.Student_ID + item.First_Name">
                <td style="display:none;"><input type="text" class="form-control" :value="item.Index_No"></td>
                <td style="display:none;">{{item.checked}}</td>
                <td>
                    <!--<vs-checkbox ref="studentCheck" v-model="item.checked"-->
                                 <!--@change="isCheck(item)"></vs-checkbox>-->
                    <div class="pen-checkbox">
                        <div class="pen-checkbox_item">
                            <input type="checkbox" v-model="item.checked" @change="isCheck(item)" :id="item.Student_ID"/>
                            <label :for="item.Student_ID"></label>
                        </div>
                    </div>
                </td>
                <td style="max-width: 15vw;"><label class="lblStudentName">{{item.First_Name}} {{item.Middle_Name}}
                    {{item.Last_Name}}</label></td>
                <td class="">
                    <div class="mass-activity-wrap" :class="{ 'showMore': item.showMore }">
                        <el-table
                                :data="item.dailyRoutine"
                                style="width: 100%">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <p>Date: {{ props.row.DrCreatedOn_convert }}</p>
                                    <p>Start: {{ props.row.DrStartTime_convert }}</p>
                                    <p>End: {{ props.row.DrEndTime_convert }}</p>
                                    <p>Remark: {{ props.row.DrRemark }}</p>
                                    <div class="routine-action">
                                        <el-button size="mini" @click="showUpdateModal(props.row,item.Student_ID)">
                                            Edit
                                        </el-button>
                                        <el-button size="mini" @click="deleteActivity(props.row)">Delete</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="DrReferenceType"
                                    row-class-name="actList-title">
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-button size="mini" @click="showMoreActivity(item)" class="massActivity-show-more"
                               v-if="item.dailyRoutine&&item.dailyRoutine.length>2">
                        <span v-if="item.showMore">Less</span>
                        <span v-if="!item.showMore">More</span>
                    </el-button>
                <td>
                    <!--<el-button type="primary" @click="compBtnAdd(item)" v-if="item.editMode">Save</el-button>-->
                    <!--<el-button type="primary" @click="changeEditMode(item)" v-else>Add</el-button>-->
                    <el-button type="primary" @click="showUpdateModal('',item.Student_ID)">Add</el-button>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
    import DataSource from "../../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';
    import $ from "jquery";

    export default {
        name: "Mass_Update_Table",
        data() {
            return {
                selectedClassStudent: [],
                newClassStudent: [],
                ddlTaskDescription: '',
                txtTimeStart: '',
                txtTimeStop: '',
                txtTimeCurrent: '',
                txtRemark: '',
                ddlRest: '',
                ddlFeed: '',
                ddlFeedBottleType: '',
                ddlLatchOn: '',
                ddlPoop: '',
                ddlTexture: '',
                ddlColor: '',
                ddlHygiene: '',
                selectionRest: '',
                selectionStartEndTime: '',
                selectionCurrentTime: '',
                selectionRemark: '',
                selectionFeed: '',
                selectionFeedBottleType: '',
                selectionLatchOn: '',
                selectionPoop: '',
                selectionTexture: '',
                selectionColor: '',
                selectionHygiene: '',
                DailyRoutineList: [],
                checkAllStudent: false
            };
        },
        mounted() {
            this.initEvent();
        },
        props: ["emitSelectedClassStudent"],
        methods: {
            async initEvent() {
                this.selectedClassStudent = this.emitSelectedClassStudent;
                this.addInitStudentValue();
            },
            addInitStudentValue() {
                this.selectedClassStudent.forEach(m => {
                    m.txtRemark = "";
                    m.editMode = false;
                    m.showMore = false;
                    m.checked = false;
                });
                this.newClassStudent = this.selectedClassStudent;
            },
            TaskDescription(item) {
                item.selectionRest = false;
                item.selectionStartEndTime = false;
                item.selectionCurrentTime = false;
                item.selectionFeed = false;
                item.selectionFeedBottleType = false;
                item.selectionLatchOn = false;
                item.selectionPoop = false;
                item.selectionTexture = false;
                item.selectionColor = false;
                item.selectionHygiene = false;
                item.selectionCurrentTime = false;
                item.selectionRemark = true;
                if (item.ddlTaskDescription === 'Rest') {
                    item.selectionRest = true;
                    item.selectionStartEndTime = true;
                } else if (item.ddlTaskDescription === 'Feed') {
                    item.selectionCurrentTime = true;
                    item.selectionFeed = true;
                    item.selectionFeedBottleType = false;
                    item.selectionLatchOn = false;

                    if (item.ddlFeed === "Bottle-Type") {
                        item.selectionFeedBottleType = true;
                    } else if (item.ddlFeed === "Latch On") {
                        item.selectionLatchOn = true;
                    }
                } else if (item.ddlTaskDescription === 'Poop') {
                    item.selectionPoop = true;
                    item.selectionTexture = false;
                    item.selectionColor = false;

                    if (item.ddlPoop === "Texture") {
                        item.selectionTexture = true;
                    } else if (item.ddlPoop === "Color") {
                        item.selectionColor = true;
                    }
                } else if (item.ddlTaskDescription === 'Hygiene') {
                    item.selectionHygiene = true;
                    item.selectionCurrentTime = true;
                }
            },
            changeEditMode(item) {
                item.editMode = true;
                this.$forceUpdate();
            },
            compBtnAdd(item) {
                try {
                    let drReferenceType = '';
                    if (item.selectionRest === true) {
                        if (item.ddlRest === "Nap") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlRest;

                        } else if (item.ddlRest === "Sleep") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlRest;
                        }
                    } else if (item.selectionFeed === true) {
                        if (item.selectionFeedBottleType === true) {
                            if (item.ddlFeedBottleType === "Formula") {
                                drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed + "|" + item.ddlFeedBottleType;
                            } else if (item.ddlFeedBottleType === "Breast Milk") {
                                drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed + "|" + item.ddlFeedBottleType;
                            }
                        } else if (item.ddlFeed === "Solid") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed;
                        } else if (item.selectionLatchOn === true) {
                            if (item.ddlLatchOn === "Left") {
                                drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed + "|" + item.ddlLatchOn;
                            } else if (item.ddlLatchOn === "Right") {
                                drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed + "|" + item.ddlLatchOn;
                            }

                        } else if (item.ddlFeed === "Menu") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlFeed;
                        }

                    } else if (item.selectionPoop === true) {
                        if (item.selectionTexture === true) {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlPoop + "|" + item.ddlTexture;
                        } else if (item.selectionColor === true) {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlPoop + "|" + item.ddlColor;
                        }

                    } else if (item.selectionHygiene === true) {
                        if (item.ddlHygiene === "Diaper change") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlHygiene;
                        } else if (item.ddlHygiene === "Shower&Diaper change") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlHygiene;
                        } else if (item.ddlHygiene === "Shower") {
                            drReferenceType = item.ddlTaskDescription + "|" + item.ddlHygiene;
                        }

                    }

                    let btnAddObject = [];
                    btnAddObject.DrStartTime = item.txtTimeStart;
                    btnAddObject.DrEndTime = item.txtTimeStop;
                    btnAddObject.DrRemark = item.DrRemark;
                    btnAddObject.studentIDArray = item.Student_ID;
                    btnAddObject.DrReferenceType = drReferenceType;

                    if (item.selectionRest === true && item.txtTimeStop === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (item.selectionRest === true && item.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (item.selectionFeed === true && item.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (item.selectionHygiene === true && item.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else {
                        const resp = DataSource.shared.addDailyRoutine(btnAddObject);
                        resp.then((resp) => {

                            if (resp.code === '1') {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Task added.',
                                    type: 'success'
                                });

                                item.editMode = false;
                                this.refreshStudentActivity();
                                this.refreshActivityField(item);
                                this.$forceUpdate();

                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error'
                                });
                                item.editMode = false;
                                this.$forceUpdate();

                            }
                        });
                    }

                } catch (e) {
                    alert(e);
                    console.log(e);
                }
            },
            async deleteActivity(act) {
                let btnDelObject = [];
                btnDelObject.DrStudentID = act.DrStudentID;
                btnDelObject.drID = act.DrID;
                const response = await DataSource.shared.deleteDailyRoutine(btnDelObject);
                if (response) {
                    switch (response.code) {
                        case "1":
                            this.$notify({
                                title: 'Success',
                                message: 'Activity Deleted',
                                type: 'success'
                            });
                            this.refreshStudentActivity();
                            break;
                    }
                }

            },
            async refreshStudentActivity() {
                try {
                    for (const selected of this.selectedClassStudent) {
                        const response = await DataSource.shared.getDailyRoutineByStudentID(selected.Student_ID);
                        selected.dailyRoutine = response.Table;
                    }
                    this.$forceUpdate();
                } catch (e) {
                    this.results = e;
                }
            },
            async refreshActivityField(item) {
                item.selectionRest = false;
                item.selectionFeed = false;
                item.selectionFeedBottleType = false;
                item.selectionLatchOn = false;
                item.selectionPoop = false;
                item.selectionTexture = false;
                item.selectionColor = false;
                item.selectionHygiene = false;
                item.selectionCurrentTime = false;

                item.ddlRest = "";
                item.ddlTaskDescription = "";
                item.ddlFeedBottleType = "";
                item.ddlFeed = "";
                item.ddlLatchOn = "";
                item.ddlPoop = "";
                item.ddlTexture = "";
                item.ddlColor = "";
                item.ddlHygiene = "";
                item.txtTimeStart = "";
                item.txtTimeStop = "";
                item.txtRemark = "";
            },
            showMoreActivity(item) {
                if (item.showMore) {
                    item.showMore = false;
                } else {
                    item.showMore = true;
                }
                this.$forceUpdate();
            },
            showUpdateModal(Routine, studentID) {
                this.$emit('showUpdateModal', Routine, studentID);
            },
            selectAllStudent() {
                if (this.checkAllStudent === true) {
                    this.newClassStudent.forEach(m => {
                        m.checked = true;
                    });
                }else{

                    this.newClassStudent.forEach(m => {
                        m.checked = false;
                    });
                }

                this.$emit('passParent', this.checkAllStudent);
            },
            isCheck(){

                const exist = this.newClassStudent.find(m => m.checked === true);
                console.log(exist,"eee")
                if(exist){
                    let isCheck = true;
                    this.$emit('passParent', isCheck);
                    console.log(isCheck,"111")

                }else{
                    let isCheck = false;
                    this.$emit('passParent', isCheck);
                    console.log(isCheck,"222")

                }
            }

        }

    };
</script>
<style>
    .mass-update-table .el-form-item__label {
        padding: 0;
        margin: 0;
        font-size: 0.8em;
        font-weight: normal;
        line-height: 2em;
        display: block !important;
        float: none;
        text-align: left;
    }

    .mass-update-table td input {
        border-radius: 5px !important;
    }

    .mass-update-table .el-textarea__inner {
        border: 0px;
    }

    .mass-activity-wrap .el-table__header-wrapper {
        display: none;
    }

    .mass-activity-wrap .el-table td {
        padding: 0px !important;
    }

    .mass-activity-wrap .el-table--enable-row-hover .el-table__body tr:hover > td,
    .mass-activity-wrap .el-table,
    .mass-activity-wrap .el-table__expanded-cell,
    .mass-activity-wrap .el-table tr {
        background: none !important;
        background-color: transparent !important;
    }

    .mass-activity-wrap .el-table td.el-table__expanded-cell {
        padding: 5px 0 5px 56px !important;
        background: none !important;
    }

    .mass-activity-wrap .el-table td.el-table__expanded-cell p {
        margin: 0px;
    }

    .mass-activity-wrap .el-table--enable-row-transition .el-table__body td {
        transition: none !important;
    }

    .mass-activity-wrap .el-table--enable-row-hover .el-table__body tr:hover {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    .mass-activity-wrap .el-table__empty-block {
        display: none;
    }


    .mass-activity-wrap .el-table__row:nth-child(n+3) {
        display: none;
    }

    .mass-activity-wrap.showMore .el-table__row:nth-child(n+3) {
        display: table-row;
        width: 100% !important;
    }

    .mass-activity-wrap tr.el-table__row.expanded .cell {
        font-weight: bold;
        color: #5d588b;
    }


</style>
<style scoped>
    .responsive-table, .responsive-table table {
        width: 100%;
    }

    .attTable td {
        vertical-align: top;
        padding: 20px 15px !important;
    }

    span.mass-table-activity {
        float: left;
        margin: 0 0 5px;
        background: #e4e7ed;
        border-color: #c5cad166;
        color: #303133;
    }

    .massActivity-show-more {
        float: left;
        background: none;
        border: 0px;
        margin: 10px 55px 0px;
        padding: 0px;
        color: #409eff;
        border-color: transparent !important;
    }

    .routine-action {
        margin: 10px 0 0 0;
    }

    .routine-action a {
        cursor: pointer;
    }

    .routine-action a:hover {
        color: #007bff !important;
    }
    .mass-update-table th .pen-checkbox {
        top: -11px;
        position: relative;
    }
    .mass-update-table th {
        padding: 20px 15px !important;
    }
</style>